"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BPEConfigType_1 = require("../../BPEConfig/BPEConfigType");
var BPVideoPagedType_1 = require("../../BPEConfig/BPVideoPagedType");
var BPElementConfig_1 = __importDefault(require("../../BPEConfig/BPElementConfig"));
var IFrameBuilder_1 = __importDefault(require("../../IIFrameBuilder/IFrameBuilder"));
var MessageListener_1 = __importDefault(require("../../Messages/MessageListener"));
var IFrameWidget_1 = __importDefault(require("../../Widgets/IFrameWidget"));
var ModalManager_1 = __importDefault(require("../modal/ModalManager"));
var RemoteVideoRequestHandler = /** @class */ (function () {
    function RemoteVideoRequestHandler(sessionManager) {
        this.iframeBuilder = new IFrameBuilder_1.default();
        this.sessionManager = sessionManager;
    }
    /**
     * Maneja la peticion de tipo video
     * @param request
     */
    RemoteVideoRequestHandler.prototype.handle = function (request) {
        this.request = request;
        //Limpiamos modal actual
        ModalManager_1.default.instance().clear();
        var config = this.createConfigForVideo();
        var iframe = this.iframeBuilder.build(config);
        var widget = new IFrameWidget_1.default(config, iframe);
        new MessageListener_1.default([widget]);
        //Si queremos que el iframe reescale debemos usar el render del widget (pasando como target el modal en el objeto BPElementConfig ) en lugar del ModalManager.instance().setContent
        //widget.render();
        //Pintamos la modal que seteamos de target en eline 46
        //ModalManager.instance().setContent(widget.getIframe());
        ModalManager_1.default.instance().render();
    };
    /**
     * Inherits config from iframe but adds contentId from recivec video
     */
    RemoteVideoRequestHandler.prototype.createConfigForVideo = function () {
        var config = new BPElementConfig_1.default();
        config.appid = this.request.frameOrigin.getConfig().appid;
        config.lang = this.request.frameOrigin.getConfig().lang;
        config.type = BPEConfigType_1.BPEConfigType.VIDEO_PAGED;
        config.width = "";
        config.height = "";
        config.target = ModalManager_1.default.instance().container();
        config.attributes.set("appid", config.appid);
        config.attributes.set("numberposts", "20");
        config.attributes.set("type", config.type);
        config.attributes.set("contentid", this.request.getNotificationEvent().data._id);
        config.attributes.set("ssid", this.sessionManager.getToken());
        config.attributes.set("autoplay", "true");
        this.setFilterConfig(config, this.request.frameOrigin.getConfig().attributes.get("type"));
        return config;
    };
    /**
     * Añade el iframe generado al body de la página
     * @param iframe
     */
    RemoteVideoRequestHandler.prototype.addIframeToWindow = function (iframe) {
        window.parent.document.body.append(iframe);
    };
    /**
     * Define el atributo filter en funcion de el tipo de widget
     * @param config
     * @param type
     */
    RemoteVideoRequestHandler.prototype.setFilterConfig = function (config, type) {
        switch (type) {
            case BPVideoPagedType_1.BPVideoPagedType.REPLIES:
            case BPVideoPagedType_1.BPVideoPagedType.REPLIES_EXTERNAL:
                config.attributes.set("filter", this.request.frameOrigin.getConfig().attributes.get("contentid"));
                break;
            case BPVideoPagedType_1.BPVideoPagedType.USER:
                config.attributes.set("filter", this.request.frameOrigin.getConfig().attributes.get("userid"));
                break;
            case BPVideoPagedType_1.BPVideoPagedType.QUERY:
                config.attributes.set("filter", this.request.frameOrigin.getConfig().attributes.get("query"));
                break;
            case BPVideoPagedType_1.BPVideoPagedType.HASHTAG:
                config.attributes.set("filter", this.request.frameOrigin.getConfig().attributes.get("hashtag"));
                break;
        }
        config.attributes.set("filter-type", this.request.frameOrigin.getConfig().attributes.get("type"));
        //TODO revisar valor de paginación
        config.attributes.set("numberposts", "10");
    };
    return RemoteVideoRequestHandler;
}());
exports.default = RemoteVideoRequestHandler;
